import pcaCode from './json/pca-code.json'
const dataMap = {
  area: pcaCode
}
export default dataMap
